import iconWalkScore from '../public/images/walk-score.svg';
import iconBikeScore from '../public/images/bike-score.svg';
import iconTransitScore from '../public/images/transit-score.svg';
import iconNightLife from '../public/images/night-life.svg';
import iconDogFriendly from '../public/images/dog-friendly.svg';
import iconGyms from '../public/images/gym.svg';
import iconRestaurants from '../public/images/restaurants.svg';
import iconGroceries from '../public/images/groceries.svg';
import iconArts from '../public/images/arts.svg';
import iconFamilyFriendly from '../public/images/family_friendly.svg';
import iconParks from '../public/images/parks.svg';
import iconCoffeeShops from '../public/images/coffee-shop.svg';

export const mainFeaturesCommonDict = [
  {
    title: 'Walkability',
    type: 'Walk_score',
    image: iconWalkScore,
    altImage: 'Walk Score Icon',
    walkscore: true,
  },
  {
    title: 'Bikeability',
    type: 'Bike_score',
    image: iconBikeScore,
    altImage: 'Bike Score Icon',
    walkscore: true,
  },
  {
    title: 'Transit',
    type: 'Transit_score',
    image: iconTransitScore,
    altImage: 'Transit Score Icon',
    walkscore: true,
  },
  {
    title: 'Night Life',
    type: 'Night_life',
    image: iconNightLife,
    altImage: 'Night Life Icon',
    walkscore: false,
  },
  {
    title: 'Dog Friendly',
    type: 'Dog_Friendly',
    image: iconDogFriendly,
    altImage: 'Dog Friendly Icon',
    walkscore: false,
  },
  {
    title: 'Gyms',
    type: 'Gyms',
    image: iconGyms,
    altImage: 'Gym Icon',
    walkscore: false,
  },
  {
    title: 'Restaurants',
    type: 'Restaurants',
    image: iconRestaurants,
    altImage: 'Restaurant Icon',
    walkscore: false,
  },
  {
    title: 'Groceries',
    type: 'Groceries',
    image: iconGroceries,
    altImage: 'Groceries Icon',
    walkscore: false,
  },
  {
    title: 'Arts & Culture',
    type: 'Arts_and_Culture',
    image: iconArts,
    altImage: 'Arts and Culture Icon',
    walkscore: false,
  },
  {
    title: 'Family Friendly',
    type: 'Family_Friendly',
    image: iconFamilyFriendly,
    altImage: 'Family Friendly Icon',
    walkscore: false,
  },
  {
    title: 'Parks',
    type: 'Parks',
    image: iconParks,
    altImage: 'Parks Icon',
    walkscore: false,
  },
  {
    title: 'Coffee Shops',
    type: 'Coffee_Shops',
    image: iconCoffeeShops,
    altImage: 'Coffee Shop Icon',
    walkscore: false,
  },
];
